import React from "react";

const WorkExperience = ({ data }) => {
    let ATG = 1, ATG2 = 2, Cathay = 3
    if (data) {
        var work = data.work.map(function (work) {
            return (
                <div key={work.company}>
                    <h3>{work.company}</h3>
                    <p className="info">
                        {work.title}
                        <span>&bull;</span> <em className="date">{work.years}</em>
                    </p>
                    <p>{work.description}</p>
                </div>
            );
        });
    }

    return (
        <div className="row work">
            <div className="three columns header-col">
                <h1>
                    <span>Work</span>
                </h1>
            </div>

            <div className="nine columns main-col">
                <div key={ATG}>
                    <h3>Applied Technology Group</h3>
                    <p className="info">
                        Software Developer
                        <span>&bull;</span> <em className="date">August 2021 - November 2021</em>
                    </p>
                    <p><ul>
                        <li>Developed webpages with React, TypeScript, Redux, Headless-UI, and GraphQL for client which improved
                            their sign-up rate by 75%</li>
                        <li>Developed webpages that were 1:1 to Figma designs</li>
                    </ul></p>
                </div>
                <div key={ATG2}>
                    <h3>Applied Technology Group</h3>
                    <p className="info">
                        Software Developement Intern
                        <span>&bull;</span> <em className="date">June 2020 - August 2020</em>
                    </p>
                    <p><ul>
                        <li>Hong Kong Science Technology Park NxTEC Summer 2020 Intern</li>
                        <li>Worked in a team to develop a clinic directory mobile-first PWA to connect patients with local doctors
                            increasing their patient base by 53%</li>
                        <li>Worked in a team to develop a web portal for ATG’s smart wearables with Vue.js, Vuetify, and Axios with
                            an Azure backend written in C#</li>
                        <li>Optimized design of web portal with designer to improve traffic</li>
                    </ul></p>
                </div>
                <div key={Cathay}>
                    <h3>Automated Systems Limited HK</h3>
                    <p className="info">
                        Helpdesk Specialist
                        <span>&bull;</span> <em className="date">May 2019 - September 2019</em>
                    </p>
                    <p><ul>
                        <li>Client: Cathay Pacific Airways Limited</li>
                        <li>Prepared and re-imaged company desktops/notebook/Macs for deployment</li>
                        <li>Provided both remote and desk-side support in a large (3000+ employee) corporate office environment</li>
                        <li>Maintained work orders using BMC Remedy software</li>
                        <li>Participated in large migration from Windows 7 to Windows 10 for 1000 users</li>
                        <li>Completed 1500+ work orders</li>
                    </ul></p>
                </div>
            </div>
        </div>
    );
};

export default WorkExperience;